import type { LineIndex } from './LineIndex';

export class ParseError extends Error {
  errors: ParseMessage[];
  warnings: ParseMessage[];

  constructor(errors: ParseMessage[], warnings: ParseMessage[]) {
    super(`Cadet parse: ${errors.length} errors, ${warnings.length} warnings`);
    this.errors = errors;
    this.warnings = warnings;
  }

  toString(): string {
    return (
      this.errors.map(e => e.toString()).join('\n') +
      '\n' +
      this.warnings.map(e => e.toString()).join('\n')
    );
  }
}

export class ParseMessage extends Error {
  prefix: string;
  context: string[];
  offset: number;
  index: LineIndex;

  constructor(
    prefix: string,
    message: string,
    context: string[],
    offset: number,
    index: LineIndex
  ) {
    super(message);
    this.prefix = prefix;
    this.context = context;
    this.offset = offset;
    this.index = index;
  }

  toStringArray(): string[] {
    const lines = [];
    const { text, line, column } = this.index.offsetToLineColumn(this.offset);
    lines.push(`| ${text}`);
    lines.push('| ' + ' '.repeat(column - 1) + '^');
    lines.push('');
    lines.push(`(:${line}:${column})`);
    lines.push(`${this.prefix}: ${this.message}`);
    if (this.context.length > 0) {
      lines.push(this.context.join(' > '));
    }
    return lines;
  }

  static formatStringArray(arr: string[]): string[] {
    const maxLength = Math.max(...arr.map(s => s.length));
    return arr.map(s => s.padEnd(maxLength, ' '));
  }

  toString(): string {
    return this.toStringArray().join('\n');
  }

  toJSON(opts?: { compact?: boolean }): object {
    if (opts?.compact) {
      return ParseMessage.formatStringArray(this.toStringArray());
    }
    return {
      message: this.message,
      prefix: this.prefix,
      context: this.context,
      offset: this.offset,
      line: this.index.offsetToLineColumn(this.offset).line,
      column: this.index.offsetToLineColumn(this.offset).column
    };
  }
}
